import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

const AnimatedGrid = () => {
  
  const rows = 12;
  const cols = 15;
  
  const tiles = useMemo(() => {
    const arr = [];
    for (let i = 0; i < rows * cols; i++) {
      arr.push(i);
    }
    return arr;
  }, [rows, cols]);

  return (
    <div className="absolute inset-0 z-0 overflow-hidden opacity-50 pointer-events-none flex items-center justify-center">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-purple-900/30 blur-[120px] rounded-full"></div>
      
      {}
      <div 
        className="absolute inset-0 w-full h-full"
        style={{
          perspective: '800px',
          transformStyle: 'preserve-3d',
        }}
      >
        <div 
          className="absolute inset-0 grid"
          style={{
            gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
            gridTemplateRows: `repeat(${rows}, minmax(0, 1fr))`,
            transform: 'rotateX(55deg) scale(2) translateY(-25%)',
            gap: '2px',
          }}
        >
          {tiles.map((i) => {
            
            const delay = Math.random() * 4;
            const duration = 2 + Math.random() * 2;
            
            const isHighlight = Math.random() > 0.85;

            return (
              <motion.div
                key={i}
                className={`bg-purple-600/20 border border-purple-500/30 rounded-sm ${isHighlight ? 'shadow-[0_0_15px_rgba(168,85,247,0.8)]' : ''}`}
                initial={{ opacity: 0.1 }}
                animate={{
                  opacity: [0.1, isHighlight ? 0.9 : 0.5, 0.1],
                  backgroundColor: [
                    'rgba(147, 51, 234, 0.1)', 
                    isHighlight ? 'rgba(147, 51, 234, 0.5)' : 'rgba(147, 51, 234, 0.2)', 
                    'rgba(147, 51, 234, 0.1)'
                  ],
                }}
                transition={{
                  duration: duration,
                  repeat: Infinity,
                  delay: delay,
                  ease: "easeInOut"
                }}
              />
            );
          })}
        </div>
      </div>
      
      {}
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-[#050505]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_20%,#050505_80%)]"></div>
    </div>
  );
};

export default AnimatedGrid;
